import { render, staticRenderFns } from "./ShipmentsTableMobile.vue?vue&type=template&id=525023aa&scoped=true"
import script from "./ShipmentsTableMobile.vue?vue&type=script&lang=js"
export * from "./ShipmentsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsTableMobile.vue?vue&type=style&index=0&id=525023aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525023aa",
  null
  
)

export default component.exports